import { PromoBoxProps } from "./types"
import { PromoBox } from "./PromoBox"

// Combo1
export const Col1Row3Span3 = (props: Omit<PromoBoxProps, "gridPosition" | "disableGrid">) => (
  <PromoBox {...props} gridPosition="Col1Row3Span3Rows" />
);

export const Col1Row10Span3 = (props: Omit<PromoBoxProps, "gridPosition" | "disableGrid">) => (
  <PromoBox {...props} gridPosition="Col1Row10Span3Cols" />
);

// Combo2
export const Col2Row3Span2RowsSpan2Cols = (props: Omit<PromoBoxProps, "gridPosition" | "disableGrid">) => (
  <PromoBox {...props} gridPosition="Col2Row3Span2RowsSpan2Cols" />
);

export const Col1Row9Span1RowsSpan1Cols = (props: Omit<PromoBoxProps, "gridPosition" | "disableGrid">) => (
  <PromoBox {...props} gridPosition="Col1Row9Span1RowsSpan1Cols" />
);

// Combo2
export const Col3Row3Span3 = (props: Omit<PromoBoxProps, "gridPosition" | "disableGrid">) => (
  <PromoBox {...props} gridPosition="Col3Row3Span3Rows" />
);

export const Col1Row8Span2 = (props: Omit<PromoBoxProps, "gridPosition" | "disableGrid">) => (
  <PromoBox {...props} gridPosition="Col1Row8Span2Rows" />
);

export const Col3Row13Span1 = (props: Omit<PromoBoxProps, "gridPosition" | "disableGrid">) => (
  <PromoBox {...props} gridPosition="Col3Row13Span1Row" />
);

// Combo4
export const Col1Row4Span2RowsSpan2Cols = (props: Omit<PromoBoxProps, "gridPosition" | "disableGrid">) => (
  <PromoBox {...props} gridPosition="Col1Row4Span2RowsSpan2Cols" />
);

export const Col2Row13Span1RowSpan2Cols = (props: Omit<PromoBoxProps, "gridPosition" | "disableGrid">) => (
  <PromoBox {...props} gridPosition="Col2Row13Span1RowSpan2Cols" />
);

// Combo5
export const Col1Row3Span1RowSpan1Col = (props: Omit<PromoBoxProps, "gridPosition" | "disableGrid">) => (
  <PromoBox {...props} gridPosition="Col1Row3Span1RowSpan1Col" />
);

export const Col1Row13Span1RowSpan1Col = (props: Omit<PromoBoxProps, "gridPosition" | "disableGrid">) => (
  <PromoBox {...props} gridPosition="Col1Row13Span1RowSpan1Col" />
);

// Combo6
export const Col1Row3Span1RowSpan2Cols = (props: Omit<PromoBoxProps, "gridPosition" | "disableGrid">) => (
  <PromoBox {...props} gridPosition="Col1Row3Span1RowSpan2Cols" />
);

export const Col3Row7Span2RowsSpan1Col = (props: Omit<PromoBoxProps, "gridPosition" | "disableGrid">) => (
  <PromoBox {...props} gridPosition="Col3Row7Span2RowsSpan1Col" />
);

export const Col1Row13Span1RowSpan2Cols = (props: Omit<PromoBoxProps, "gridPosition" | "disableGrid">) => (
  <PromoBox {...props} gridPosition="Col1Row13Span1RowSpan2Cols" />
);

// Combo7
export const Col1Row11Span3RowsSpan1Col = (props: Omit<PromoBoxProps, "gridPosition" | "disableGrid">) => (
  <PromoBox {...props} gridPosition="Col1Row11Span3RowsSpan1Col" />
);